import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, UntypedFormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TableField } from '@app/modules/security-setup/models/table-field.model';

@Component({
  selector: 'app-column-mapping-dialog',
  templateUrl: './column-mapping-dialog.component.html',
  styleUrls: ['./column-mapping-dialog.component.scss']
})
export class ColumnMappingDialogComponent implements OnInit {
  fields: TableField[] = [];
  columnMapping: FormGroup;
  originalData: any;
  columnMappingTypes: any;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<ColumnMappingDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data
  ) {
    this.fields = data.fields;
    this.originalData = data.columnMapping.value;
    this.columnMapping = data.columnMapping;
    this.columnMappingTypes = data.columnMappingTypes;
  }

  ngOnInit(): void {
  }

  get showImportMappingTypeField(): boolean {
    const tableFieldValue = this.columnMapping?.get('tableField')?.value;
    
    if (!tableFieldValue) {
      return true;
    }
    
    const fieldsRequiringMapping = [
      'tfi_PositionParent',
      'tfi_DisciplineConductedBy',
      'tbl_IeEmployee',
      'tfi_ManAdjEmployee', // Time Off Manual Adjustment - employee
      'tfi_ToilManAdjEmployee', // TOIL Manual Adjustment - employee
      'tfi_PeEmployee', //Position employee - employee
      'tfi_PePosition' //Position employee - position
    ];
    
    return fieldsRequiringMapping.includes(tableFieldValue);
  }
  

  isAlookupField(fieldId: string): boolean {
    const selectedField = this.fields?.find(field => field.id === fieldId);

    if (!selectedField || !selectedField.properties) {
      return false;
    }
    return selectedField.properties.some(
      (prop: { property: string; value: string }) =>
        prop.property === 'ListGroup' && !!prop.value
    );
  }

  close(): void {
    this.columnMapping.reset(this.originalData);
    this.dialogRef.close(false);
  }

  save(): void {
    this.dialogRef.close();
  }
}
